<template>
	<Modal 
		v-model='visiable'
		:mask-closable='false'
		:closable='false'
		:footer-hide='true'
	>
		<div>
			<div class="header">恭喜达标255PV活动，您可选择<span style='text-decoration: underline;padding: 0 5px;font-weight:bold;color:red;'>{{promote.num}}</span>份赠品：</div>
			<div class="main-body">
				<div class='product' v-for='product in promote.optionals'>
					<div class="img">
						<img src="@/assets/order/errorImg2.png" v-real-img="product.image_path_big">
					</div>
					<div class="right">
						<p class="name">{{product.name}}</p>
						<template v-if='stock(product).stock>0 && promote.control != 20'>
							<div class='stepper'>
								<div class="button-primary sub" @click="modifyPromote(product,-1)">
									<Icon type="md-remove" />
								</div>
								<Input disabled :value='product.num' class="detailInput" style='width: 40px;' size='small' readonly></Input>
								<div class="button-primary add" @click="modifyPromote(product,1)">
									<Icon type="md-add" />
								</div>
							</div>
						</template>
						<div v-else class='show_nogiven'><span>{{getNoStockText(product)}}</span></div>
					</div>
				</div>
			</div>
			<div class="footer">
				<Button class='foot-btn' type='primary' size='large' @click='confirm'>确认</Button>
			</div>
		</div>
	</Modal>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				visiable:false,
				promote:{},
				resolve:null,
				storeId:'501',
			}
		},
		// props:{
		// 	promote:{
		// 		type:Object,
		// 		default:()=>{}
		// 	}
		// },
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({
				promoteList: (state) => state.order.promote,
				combinePromote:(state) => state.order.combinePromote,
			}),
		},
		methods: {
			...mapActions([
				
			]),
			...mapMutations([
				'SET_PROMTE',
				'SET_COMBINEPROMOTEPRODUCT',
			]),
			async initData(){

			},
			getNoStockText(product){
				if (product.product_flag == 1 || product.product_flag == -30) {
					return "已领完";
				}
				return "暂领完";
			},
			getStoreId(){
				return this.storeId
			},
			stock(product){
				return product.store_id.filter(item=>item.store_id == this.storeId)[0]
			},
			show(promote,storeId){
				this.promote = promote
				let total = this.promote.optionals.reduce((prev,cur)=>{
					return prev + cur.num
				},0)
				let max_num = this.promote.num
				if (total > max_num || storeId != this.storeId) {
					this.promote.optionals.forEach(item=>item.num = 0);
				}
				this.storeId = storeId
				this.visiable = true
			},
			asyncshow(promote,storeId) {
				this.show(promote,storeId)
				return new Promise((resolve,reject)=>{
					this.resolve = resolve
				})
			},
			confirm(){
				let total = this.promote.optionals.reduce((prev,cur)=>{
					return prev + cur.num
				},0)
				let max_num = this.promote.num
				if (total != max_num) {
					this.$Toast.show('请选择正确的数量', { duration: 3000 });
					return
				}
				this.promoteList.value.filter(item=>item.code == this.promote.promote_code).map(item=>{
					item.detail[0].optionals = this.promote.optionals
					return item
				})
				this.SET_PROMTE(this.promoteList)
				this.saveProductNum(this.promote)
				this.visiable = false
				this.resolve && this.resolve(1)
			},
			modifyPromote(product,factor){
				let num = product.num
				if (factor == 1) {
					let max_num = this.promote.num
					let total = this.promote.optionals.reduce((prev,cur)=>{
						return prev + cur.num
					},0)
					let stock = product.store_id.filter(item=>item.store_id == this.storeId)[0]
					if (total >= max_num) {
						this.$Toast.show('赠品已经是最大赠送数量', { duration: 3000 });
						return
					}
					if (stock.stock < num + factor) {
						this.$Toast.show(`${product.name}库存不足`, { duration: 3000 });
						return
					}
					product.num = num + factor
					
				} else {
					if (num == 0) return
					product.num = num + factor
				}

			},
			async saveProductNum(promote) {
				let res = this.combinePromote || {}
				res[promote.promote_code] =  res[promote.promote_code] || {}
				promote.optionals.forEach(optional=>{
					res[promote.promote_code][optional.sku] = optional.num
				})
				this.SET_COMBINEPROMOTEPRODUCT(res)
			}
		},
	}
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
	.header {
		@include fontSize($font-size-15);
	}
	.product {
		display:flex;
		align-items: center;
		.img {
			width: 140px;
			height: auto;
			display: block; // height: 80px;
			min-height: 80px;
			img {
				width:100%;
				display:block;
			}
		}
		.right {
			flex:1;
			.name {
				@include fontSize($font-size-15);
			}
		}
	}
	.stepper {
		display:flex;
		align-items: center;
		height: 30px;
		gap:10px;
		margin-top: 15px;
		.sub,.add {
			color: white;
			width: 30px;
			height: 30px;
			text-align: center;
			border-radius: 5px;
		}
	}
	.show_nogiven {
		margin-top: 15px;
		span {
			color:white;
			font-weight: bold;
			background-color:#ccc;
			padding:5px 10px;
		}
	}
	.footer {
		display:flex;
		justify-content: flex-end;
		.foot-btn {
			width:160px;
		}
	}
</style>